import { createRoute } from "@tanstack/react-router";

import { requireSession } from "@platform/auth/guards";
import { rootRoute } from "@platform/root";
import { AppShell } from "@platform/features/shell";

// Pathless layout route: the authenticated app shell. Wraps every signed-in page
// and enforces a session. Pages attach via getParentRoute: () => shellRoute.
export const shellRoute = createRoute({
	getParentRoute: () => rootRoute,
	id: "shell",
	beforeLoad: ({ context }) => requireSession(context.queryClient),
	component: AppShell,
});
